export const stats: [string, string][] = [
  ['8', 'VOLUMI COMPLETI'],
  ['2.752', 'ESERCIZI PRONTI'],
  ['64', 'UNITÀ DIDATTICHE'],
  ['480+', 'PAGINE DI CONTENUTI'],
]
